import type { PropsWithChildren } from "react";

export function DataTableInputWrapper({ children }: PropsWithChildren) {
	return (
		<div className="px-0 -py-2 w-full absolute inset-0 flex-center [&:has(input:focus)]:border-accent-500/10 [&:has(*:focus)_.focus-ring-border]:flex!">
			{children}
			<div className="absolute inset-0 border-primary-500 border flex-center hidden pointer-events-none focus-ring-border" />
		</div>
	);
}
